import { gql } from "@apollo/client";

export default gql`
  query getHumanReplyLearningJobs($customerId: ID!, $limit: Int){
    getHumanReplyLearningJobs(customerId: $customerId, limit: $limit){
        success
        data{
            jobId
            customerId
            status
            mode
            totalConversations
            processedConversations
            skippedConversations
            failedConversations
            remainingConversations
            progressPercent
            extractedPairs
            savedPairs
            duplicatePairs
            resolvedConflictPairs
            totalInputTokens
            totalOutputTokens
            totalEstimatedCost
            modelsUsed
            usageByModel{
                model
                requests
                inputTokens
                outputTokens
                estimatedCost
            }
            costBreakdown{
                stage
                model
                requests
                inputTokens
                outputTokens
                estimatedCost
            }
            currentConversationId
            failures{
                customerId
                conversationId
                reason
            }
            resolvedConflicts{
                conversationId
                existingAiKnowledgeSourceContentId
                newQuestion
                newAnswer
                existingQuestion
                existingAnswer
                reason
            }
            rateLimitedAt
            rateLimitResumeAt
            rateLimitRetryCount
            createdAt
            startedAt
            finishedAt
            cancelRequestedAt
            cancelledAt
            countedAt
            updatedAt
        }
        code
        message
    }
}
`
